import React, { ReactElement, InputHTMLAttributes } from "react";
import MaatschappijKeuzeLijst, { MaatschappijKeuzelijstProps } from "./MaatschappijKeuzeLijst";
import classnames from "classnames";
import { LabelProps, Label } from "adviesbox-shared";

type LabeledMaatschappijKeuzelijstProps = LabelProps & MaatschappijKeuzelijstProps;

const LabeledMaatschappijKeuzelijst = ({
  soort,
  caption,
  name,
  tooltip,
  appendChildren,
  readonly,
  visible,
  fieldSize,
  emptyValue,
  labelColSize = 5,
  onChange,
  addAnders = false,
  inclInactievePartijen = false
}: LabeledMaatschappijKeuzelijstProps & InputHTMLAttributes<HTMLSelectElement>): ReactElement => {
  const inputColSize = labelColSize < 12 ? 12 - labelColSize : 12;

  return (
    <div
      className={classnames("form-group form-row", {
        invisible: visible === false
      })}
    >
      <div className={`col-${labelColSize}`}>
        <Label caption={caption} name={name} tooltip={tooltip} />
      </div>
      <div className={`col-${inputColSize}`}>
        <MaatschappijKeuzeLijst
          soort={soort}
          name={name}
          appendChildren={appendChildren}
          readonly={readonly}
          fieldSize={fieldSize}
          emptyValue={emptyValue}
          onChange={onChange}
          addAnders={addAnders}
          inclInactievePartijen={inclInactievePartijen}
        />
      </div>
    </div>
  );
};

LabeledMaatschappijKeuzelijst.displayName = "LabeledMaatschappijKeuzelijst";
export default LabeledMaatschappijKeuzelijst;
